import React, {useRef, useState} from 'react';
import intl from "react-intl-universal";
import classNames from "classnames";

import {Button} from "../../components/Button";
import {logErrorToSentry} from "../../../utils/errors/logErrorToSentry";
import {useNotification} from "../../hooks/useNotification";

import {selectText} from "../../../utils/selectRange";


import './InviteLink.css';


export interface InviteLinkProps {
    inviteLink: string;
    className?: string;
}

export const InviteLink = ({inviteLink, className}: InviteLinkProps) => {
    const linkRef = useRef<HTMLInputElement>(null);
    const [isCopied, setCopy] = useState<boolean>(false);
    const {enqueueSnackbar} = useNotification();

    return (
        <div className={classNames({
            'InviteLink': true,
            [className!]: className
        })}>
            <input
                className='InviteLink_link'
                onClick={(e) => selectText(e.target as unknown as HTMLElement)}
                ref={linkRef}
                value={inviteLink}
                readOnly={true}
            />
            <Button
                className='InviteLink_button'
                type="primary"
                onClick={() => {
                    const node = linkRef.current!;
                    node.select();
                    if (navigator.clipboard) {
                        navigator.clipboard.writeText(node.value).then(() => {
                            setCopy(true);
                        }).catch(logErrorToSentry);
                    } else {
                        enqueueSnackbar({
                            message: intl.get('failed.copy_to_clipboard').d('please copy manually'),
                            variant: 'warning',
                        });
                    }
                }}
                text={
                    !isCopied
                        ? intl.get('common.copy').d('Copy')
                        : intl.get('common.copied').d('Copied')
                }
                size='lg'
            />
        </div>
    )
}
